import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../graphql/GraphQlProvider';

export interface DeleteCreditCardFeeInput {
    id: number
}

interface CreditCardFee {
    id: number;
}

export const gqlCreditCardFee = `
    id,
`;

interface DeleteCreditCardFeeData {
    __typename?: string,
    deleteCreditCardFee: CreditCardFee
}

export const DELETE_CREDIT_CARD_FEE_MUTATION = gql`
    mutation deleteCreditCardFee($id: Int!){
        deleteCreditCardFee(id: $id){
            ${gqlCreditCardFee}
        }
    }
`;

export const deleteCreditCardFee = () => useMutation<DeleteCreditCardFeeData, DeleteCreditCardFeeInput>(
    DELETE_CREDIT_CARD_FEE_MUTATION,
    {
        update: updateCacheByType('CreditCardFee'),
    }
);

export default deleteCreditCardFee;
